import React, { useEffect, useRef } from 'react';
import './UnitMap.scss';

interface UnitMapProps {
    lat: number;
    lng: number;
    zoom?: number;
}

const SCRIPT_ID = 'google-maps-js-api';
const CALLBACK_NAME = '__unitMapInit__';

export const UnitMap: React.FC<UnitMapProps> = ({ lat, lng, zoom = 15 }) => {
    const mapRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const initMap = () => {
            if (!mapRef.current) return;
            const google = (window as any).google;
            const map = new google.maps.Map(mapRef.current, {
                center: { lat, lng },
                zoom,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
            });
            new google.maps.Marker({ position: { lat, lng }, map });
        };

        if ((window as any).google?.maps) {
            initMap();
            return;
        }

        (window as any)[CALLBACK_NAME] = initMap;

        if (!document.getElementById(SCRIPT_ID)) {
            const script = document.createElement('script');
            script.id = SCRIPT_ID;
            script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&callback=${CALLBACK_NAME}`;
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        }

        return () => {
            delete (window as any)[CALLBACK_NAME];
        };
    }, [lat, lng, zoom]);

    return <div ref={mapRef} className="unit-map" />;
};
